import React from "react";
import styles from "./Style.module.css";
import DashboardSnackbar from "../../../components/Snackbar.component";
import logoImage from "../../../assets/CRMAssets/psconnect_login_logo@2x.png";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import useForgotPasswordHook from "./ForgotPassword.hook";
import CustomTextField from "../../../components/FormFields/TextField/TextField.component";
import { useTheme } from "@mui/styles";
import { ArrowPrimaryButton } from "../../../components/Buttons/PrimaryButton";
import { ArrowBack } from "@mui/icons-material";

function ForgotPasswordView() {
  const theme = useTheme();
  const {
    handleSubmit,
    onBlurHandler,
    changeTextData,
    form,
    errorData,
    isSubmitting,
  } = useForgotPasswordHook();

  return (
    <div className={"login"}>
      <div className={styles.overlay}></div>
      <div className={styles.mainLoginView}></div>
      <div className={styles.container}>
        <div className={styles.loginFlex2}>
          <div className={styles.logoImageData}>
            <img src={logoImage} alt="text_data" style={{ width: "250px" }} />
          </div>
          <div className={styles.signContainer}>
            <div className={styles.loginHeaderText}>
              <Typography variant="h3">Forgot Password</Typography>

              <Typography
                variant={"body1"}
                sx={{ color: theme?.palette?.text?.secondary }}
              >
                Enter your registered email address and we'll send you a link to reset your password.
              </Typography>
            </div>

            <div className={styles.formContainer}>
              <div className={styles.formFlexGrouup}>
                <div className={"formGroup"}>
                  <CustomTextField
                    isError={errorData?.email}
                    errorText={errorData?.email}
                    label={
                      <>
                        Email ID
                        <span style={{ color: theme.palette.error.main }}>
                          *
                        </span>
                      </>
                    }
                    value={form?.email}
                    onTextChange={(text) => {
                      changeTextData(text, "email");
                    }}
                    onBlur={() => {
                      onBlurHandler("email");
                    }}
                  />
                </div>
              </div>
            </div>

            <div className={styles.logFlex}>
              <div className={styles.negativeSpacing} style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Link to="/login" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                  <ArrowBack sx={{ fontSize: '18px', marginRight: '5px', color: theme?.palette?.primary?.main || '#2063ce' }} />
                  <Typography
                    variant="body2"
                    style={{ cursor: "pointer", color: theme?.palette?.primary?.main || '#2063ce', fontWeight: 'bold' }}
                  >
                    Back to Login
                  </Typography>
                </Link>
                <div className={styles.loginAction}>
                  <ArrowPrimaryButton
                    variant={"h6"}
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    SEND RESET LINK
                  </ArrowPrimaryButton>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DashboardSnackbar />
      </div>
    </div>
  );
}

export default ForgotPasswordView;
